module.exports = __webpack_public_path__ + "3016dc368677be02b8c54b5ec7bdd505.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FranklinGothic-Hvy-webfont.ttf
// module id = 78
// module chunks = 0